import React, { useState, } from "react";
import json from "./CertificateJson/Certificate.json";
import Icon from "../../Component/MySkills/Icon.jsx";
import { ArrowSmDownIcon } from "@heroicons/react/outline";

import webpdf from "../../Image/web.pdf";
import Mern from "../../Image/MERN.pdf";
import Tailwind from "../../Image/tailwind.pdf"
const Certification = () => {
  const [animate, setAnimate] = useState();
  const [animate1, setAnimate1] = useState();
  const [animate2, setAnimate2] = useState();
  const onButtonClick = (e, data1) => {
    if (data1 === "web") {
      setAnimate(true);

      setTimeout(() => {
        fetch(webpdf).then((response) => {
          response.blob().then((blob) => {
            // Creating new object of PDF file
            const fileURL = window.URL.createObjectURL(blob);
            // Setting various property values
            let alink = document.createElement("a");
            alink.href = fileURL;
            alink.download = "HTML_CSS.pdf";
            alink.click();
          });
        });
        setAnimate(false);
      }, 1000);
    }
    if (data1 === "MERN") {
      let data;
      setTimeout(() => {
        // using Java Script method to get PDF file
        data = fetch(Mern).then((response) => {
          response.blob().then((blob) => {
            // Creating new object of PDF file
            const fileURL = window.URL.createObjectURL(blob);
            // Setting various property values
            let alink = document.createElement("a");
            alink.href = fileURL;
            alink.download = "ReactCertificate.pdf";
            alink.click();
          });
        });
        setAnimate1(false);
      }, 1000);
      if (!data) {
        return <>{setAnimate1(true)}</>;
      }
    }
    if (data1 === "Tail") {
      let data;
      setTimeout(() => {
        // using Java Script method to get PDF file
        data = fetch(Tailwind).then((response) => {
          response.blob().then((blob) => {
            // Creating new object of PDF file
            const fileURL = window.URL.createObjectURL(blob);
            // Setting various property values
            let alink = document.createElement("a");
            alink.href = fileURL;
            alink.download = "TailwindCertificate.pdf";
            alink.click();
          });
        });
        setAnimate2(false);
      }, 1000);
      if (!data) {
        return <>{setAnimate2(true)}</>;
      }
    }
  };
  return (
    <center>
      <div className="">
        <div className="mt-8 grid grid-cols-2 gap-4 lg:w-[80%]   lg:grid-cols-2 ">
          {json &&
            json.map((item, index) => {
              return (
                <div className="shadow-lg  shadow-[#30dada] dark:shadow-[#17A6DB]  hover:duration-500  hover:translate-x-5 rounded-[16px] border-[4px] border-[#17A6DB] py-4 dark:border-[#30dada]">
                  <div>
                    <div className=" mb-4">
                      <Icon iconType={item.Icon} />
                      <p className="  ml-4 mt-2 text-[12px] font-bold text-[#17A6DB]   dark:text-[#30dada] lg:text-[24px]">
                        {item.tech}
                      </p>
                    </div>
                    <div className="horizontal1"></div>
                  </div>
                  {item.pdf === "web" && (
                    <button
                      onClick={(e) => onButtonClick(e, item.pdf)}
                      className="shadow-[40px] flex rounded-[48px]  py-3  text-md  lg:text-lg font-normal duration-200  dark:text-white    md:text-3xl"
                    >
                      <p className="mt-2">{animate ? "Downloading..." : "Certificate"}</p>

                      <ArrowSmDownIcon
                        className="w-6 mt-2 text-[#17A6DB] dark:text-[#30dada] md:w-10 lg:mt-0"/>
                    </button>
                  )}
                  {item.pdf === "MERN" && (
                    <button
                      onClick={(e) => onButtonClick(e, item.pdf)}
                      className="shadow-[40px] flex rounded-[48px]  py-3 text-md  lg:text-lg font-normal duration-200  dark:text-white    md:text-3xl"
                    >
                      <p className="mt-2">{animate1 ? "Downloading..." : "Certificate"}</p>
                      <ArrowSmDownIcon
                        className="ml-2 w-6 mt-2 text-[#17A6DB] dark:text-[#30dada] md:w-10 lg:mt-0 "

                      />
                    </button>
                  )}
                  {item.pdf === "Tail" && (
                    <button
                      onClick={(e) => onButtonClick(e, item.pdf)}
                      className="shadow-[40px] flex rounded-[48px]  py-3 text-md  lg:text-lg font-normal duration-200  dark:text-white    md:text-3xl"
                    >
                       <p className="mt-1 dark:text-[#FFFFFF]">{animate2 ? "Downloading..." : "Certificate"}</p>
                      <ArrowSmDownIcon
                        className={"ml-2 w-6 mt-2 text-[#17A6DB] dark:text-[#30dada] md:w-10  lg:mt-0"}/>
                    </button>
                  )}
                </div>
              );
            })}
        </div>
    
      </div>
    </center>
  );
};

export default Certification;
